import { Structure } from "@/types/structure";
import { Spec } from "@/types/specList";

export const findMatchingStructure = (spec: Spec, structures: Structure[]) => {
  let match: Structure | null = null;

  for (const structure of structures) {
    const structureName = structure.name;
    if (
      structureName === spec.dutNames ||
      structureName === spec.reportName ||
      structureName === spec.legacyNames ||
      structureName === spec.name
    ) {
      match = structure;
      break;
    }
  }

  return match;
};
